import { Box} from "@mui/material";

const BillingBreadcrumb = ({ title }) => {
  return (
      <Box
        sx={{
          padding: "40px 0",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          "& ul": {
            padding: 0,
            display: "flex",
          },
          "& .BillingBreadcrumbList li": {
            display: "inline-flex",
            alignItems: "center",
            fontSize: "14px",
            lineHeight: "21px",
            fontWeight: "400",
            fontFamily: `"Quicksand", sans-serif`,
          },
          "& .BillingBreadcrumbList li a": {
            color: "#253D4E",
          },
          "& .BillingBreadcrumbList li span": {
            margin: "0 7px",
          },
          "& .BillingBreadcrumbList li.active": {
            color: "#008BFF",
            display: "flex",
            alignItems: "center",
            textDecoration: "none",
            fontWeight: '700',
          },
        }}
      >
        <Box style={{width: "100%"}}>
          <ul className="BillingBreadcrumbList">
            <li>
              <a href="/account">
              Account <span>/</span>
              </a>
            </li>
            <li>
              <a href="/">
             My Account<span>/</span>
              </a>
            </li>
            <li>
              <a href="/">
               Product <span>/</span>
              </a>
            </li>
            <li>
              <a href="/">
              View Cart<span>/</span>
              </a>
            </li>
            <li className="active">Checkout</li>
          </ul>
        </Box>
      </Box>
  );
};

export default BillingBreadcrumb;
